const _excluded = ["workspace"],
  _excluded2 = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { TextButton, PopoverOnHover, MenuItem, Typography } from 'seagull';
import { WideArrowDownward, Company24, Plus } from 'seagull/icons';
import { useStore, useStoreActions } from "../../../../../contexts";
import { useSwitchBusiness } from "../../../../../hooks/useSwitchBusiness";
import { selectors } from "../../../../../store/state-selectors";
import styles from "./BusinessSwitcher.module.scss";
import { getBusinessTriggerSubtext, getBusinessTriggerLogoUrl } from "./BusinessSwitcher.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const testIdPrefix = 'business-switcher';
const Logo = _ref => {
  let {
    src,
    className,
    testid
  } = _ref;
  const [loadingImage, setLoadingImage] = useState(true);
  const [imageError, setImageError] = useState(false);
  useEffect(() => {
    setLoadingImage(true);
    setImageError(false);
  }, [src]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.logo, className),
    children: [(loadingImage || imageError) && /*#__PURE__*/_jsx("div", {
      className: styles.companyLogoPlaceholder,
      children: /*#__PURE__*/_jsx(Company24, {})
    }), !imageError && /*#__PURE__*/_jsx("img", {
      src: src || '',
      className: cn(styles.logoImage, {
        [styles.loadingLogoImage]: loadingImage
      }),
      "data-testid": "".concat(testid, "-logo"),
      height: "24px",
      width: "43px",
      onLoad: () => {
        setLoadingImage(false);
      },
      onError: () => {
        setLoadingImage(false);
        setImageError(true);
      }
    })]
  });
};
const BusinessSwitcherItem = _ref2 => {
  let {
      workspace
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs(MenuItem, _objectSpread(_objectSpread({
    value: workspace.id(),
    className: styles.selectableItem
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx(Logo, {
      src: workspace.getBusinessSwitcherItemLogoUrl(),
      className: cn(styles.imageAsideText, styles.asItemList),
      testid: rest['data-testid']
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.accountDescription,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        ellipsis: true,
        children: workspace.name()
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        ellipsis: true,
        children: workspace.getBusinessSwitcherItemSubtext()
      })]
    })]
  }));
};
const BusinessSwitcherCreateNew = _ref3 => {
  let {
      id
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({
    value: id,
    className: styles.selectableItem,
    height: 20
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph1",
      skin: "link",
      ellipsis: true,
      className: styles.createNewLabel,
      children: [/*#__PURE__*/_jsx(Plus, {}), " Create an additional account"]
    })
  }));
};
export const BusinessSwitcher = _ref4 => {
  let {
    userInfo
  } = _ref4;
  const {
    logBI,
    resetBusinessData,
    setWorksAt
  } = useStoreActions();
  const {
    switchBusiness
  } = useSwitchBusiness();
  const isVendor = useStore(selectors.user.isVendor);
  const [open, setOpen] = useState(false);
  const validWorkspaces = (userInfo.workspaces() || []).filter(workspace => workspace.isCompletelySetupAndDisplayable());
  return /*#__PURE__*/_jsx("div", {
    "data-testid": testIdPrefix,
    children: validWorkspaces.length > 1 || isVendor ? /*#__PURE__*/_jsx(PopoverOnHover, {
      openStrategy: "click",
      removePadding: true,
      isOpen: open,
      onOpen: () => setOpen(true),
      trigger: triggerProps => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, triggerProps), {}, {
        className: styles.trigger,
        children: /*#__PURE__*/_jsx(TextButton, {
          "data-testid": "".concat(testIdPrefix, "-trigger"),
          prefixIcon: /*#__PURE__*/_jsx(Logo, {
            src: getBusinessTriggerLogoUrl(userInfo.business()),
            testid: "".concat(testIdPrefix, "-trigger")
          }),
          suffixIcon: /*#__PURE__*/_jsx(WideArrowDownward, {}),
          skin: "secondary",
          underline: "none",
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.accountDescription,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph1",
              ellipsis: true,
              children: userInfo.businessName()
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph2",
              skin: "secondary",
              ellipsis: true,
              children: getBusinessTriggerSubtext(userInfo.business())
            })]
          })
        })
      })),
      content: /*#__PURE__*/_jsxs("div", {
        className: styles.popover,
        children: [validWorkspaces.map((workspace, idx) => /*#__PURE__*/_jsx(BusinessSwitcherItem, {
          "data-testid": "".concat(testIdPrefix, "-item-").concat(idx),
          workspace: workspace,
          onClick: () => {
            setOpen(false);
            switchBusiness(workspace.id());
          }
        }, workspace.id())), isVendor && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.separator
          }), /*#__PURE__*/_jsx(BusinessSwitcherCreateNew, {
            id: "create-new",
            "data-testid": "".concat(testIdPrefix, "-item-create-new"),
            onClick: () => {
              setOpen(false);
              logBI(11151);
              resetBusinessData();
              setWorksAt();
            }
          }, "create-new")]
        })]
      })
    }) : /*#__PURE__*/_jsxs("div", {
      "data-testid": "".concat(testIdPrefix, "-current-business-view-only"),
      className: styles.currentBusinessViewOnly,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.imageAsideText,
        children: /*#__PURE__*/_jsx(Logo, {
          src: getBusinessTriggerLogoUrl(userInfo.business()),
          testid: "".concat(testIdPrefix, "-current-business-view-only")
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.viewOnlyText,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          ellipsis: true,
          children: userInfo.businessName()
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          ellipsis: true,
          children: getBusinessTriggerSubtext(userInfo.business())
        })]
      })]
    })
  });
};